import React from "react";
import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";

export default createSvgIcon(
  <React.Fragment>
    <path d="M6.002 18L10 22l-5 1 1.002-5zm12-12L22 10 10.996 21 7 16.997 18.002 6zm4.571-1.418l.132.123.584.584h.003l.123.133c.78.906.778 2.252-.005 3.156l-.123.132-.29.29L19 4.997l.296-.295c.9-.895 2.33-.935 3.277-.12z" />
  </React.Fragment>,
  `EditIcon`
);
